export default __webpack_public_path__ + "static/media/SFCINEMA(RN).e7064acd.png";